// extracted by mini-css-extract-plugin
module.exports = {"title":"Custom404Template_title__NiwTp","descrizione":"Custom404Template_descrizione__fmAf_","homeBtnContainer":"Custom404Template_homeBtnContainer__SUekZ"};